import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';
import MemberBanner from './MemberBanner/MemberBanner';

const MemberForm = () => {
    return (
        <div>
            <Navigation></Navigation>
            <MemberBanner></MemberBanner>
        </div>
    );
};

export default MemberForm;